import React, {useEffect, useImperativeHandle, useState} from "react";
import {Button, StepProps, Steps} from "antd";
import {CurrentStepSVG, FinishedStepSVG} from "assets";
import "./StepInfo.scss";
import {useAppSelector} from "redux/hooks";
import {examinationService} from "api";
import {items} from "layout/main-layout/header/config";
const StepInfo = React.forwardRef((props, ref) => {
  const [items, setItems] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const idPhieuKham = useAppSelector(state => state.common.idPhieuKham);
  const currentRoom = useAppSelector(state => state.common.currentRoom);
  useEffect(() => {}, [data]);
  useEffect(() => {
    if (idPhieuKham != null) {
      getLichSuPhong(idPhieuKham);
    }
  }, [idPhieuKham]);

  useImperativeHandle(ref, () => ({
    getLichSuPhong: idPhieuKham => {
      getLichSuPhong(idPhieuKham);
    },
    setData: [],
  }));
  const getLichSuPhong = async (idPhieuKham?) => {
    try {
      const res = (await examinationService.getLichSuPhong(idPhieuKham)) || [];

      setData(res);
    } catch (error) {
    }
  };
  useEffect(() => {
    handleData([
      ...data,
      {
        tenPhong: currentRoom,
        current: true,
      },
    ]);
  }, [currentRoom, data]);

  const handleData = data => {
    let newItems: StepProps[] = data.map((e: any, index) => {
      if (e?.tenPhong) {
        return {
          title: e?.tenPhong,
          description: e?.tenBacSy,
          status: "finish",
          icon: (
            <>
              {e.current ? (
                <CurrentStepSVG></CurrentStepSVG>
              ) : (
                <FinishedStepSVG></FinishedStepSVG>
              )}
            </>
          ),
        };
      }

      // if (index != items.length - 1) {
      //   return {
      //     title: e?.tenPhong,
      //     description: e?.tenBacSy,
      //     status: "finish",
      //     icon: <FinishedStepSVG />,
      //   };
      // } else {
      //   return {
      //     title: e?.tenPhong,
      //     description: e?.tenBacSy,
      //     status: "finish",

      //     icon: <FinishedStepSVG />,
      //   };
      // }
    });
    setItems(newItems);
  };
  // const items: StepProps[] = [
  //   {
  //     title: "Opt.Vũ Thị Minh Thư",
  //     status: "finish",
  //     icon: <FinishedStepSVG />,
  //   },
  //   {
  //     title: "WI: Phòng Bác Sỹ 1",
  //     status: "finish",
  //     icon: <FinishedStepSVG />,
  //   },
  //   {
  //     title: "WI: Hoang Thi Hanh",
  //     status: "finish",
  //     icon: <FinishedStepSVG />,
  //   },
  //   {
  //     title: "DR.Hoang Thi Hanh",
  //     status: "finish",
  //     icon: <FinishedStepSVG />,
  //   },
  //   {
  //     title: "NR.Nguyễn Thị Thu Hương",
  //     status: "wait",
  //     icon: <CurrentStepSVG />,
  //   },
  //   {
  //     title: "WI: Hoang Thi Hanh",
  //     status: "finish",
  //     icon: <FinishedStepSVG />,
  //   },
  //   {
  //     title: "DR.Hoang Thi Hanh",
  //     status: "finish",
  //     icon: <FinishedStepSVG />,
  //   },
  //   {
  //     title: "NR.Nguyễn Thị Thu Hương",
  //     status: "wait",
  //     icon: <CurrentStepSVG />,
  //   },
  // ];
  return (
    <div className="step-info">
      {data && <Steps size="small" items={items} type="default"></Steps>}
    </div>
  );
});
export default StepInfo;
